import React from 'react';
import { Flex, Button } from '@chakra-ui/react';
import { Link } from 'react-router-dom';
import PageHeadingWithTrialProgress from '../dashboard/PageHeadingWithTrialProgress';
import { useIsReadOnly } from '../../../hooks/useIsReadOnly';
import LockedActionButton from '../../common/LockedActionButton';

function MessagesHeader({ isCreatePage }) {
  const isReadOnly = useIsReadOnly();

  return (
    <>
      <PageHeadingWithTrialProgress
        title={isCreatePage ? 'New message' : 'Message History'}
      />
      <Flex justifyContent="flex-end" w="100%" mb="10px">
        {isReadOnly && !isCreatePage ? (
          <LockedActionButton
            reason="send-messages"
            mr={{ base: '0px', sm: '10px' }}
            px={{ base: '20px', sm: '40px' }}
            size="sm"
          >
            New message
          </LockedActionButton>
        ) : (
          <Button
            alt="New message"
            mr={{ base: '0px', sm: '10px' }}
            px={{ base: '20px', sm: '40px' }}
            size="sm"
            as={Link}
            to={isCreatePage ? '/messaging' : '/messaging/create'}
          >
            {isCreatePage ? 'Message History' : 'New message'}
          </Button>
        )}
      </Flex>
    </>
  );
}

export default MessagesHeader;
